export enum Mnemonicos {
  CATADM = 'CAT-ADM',
  CATUASG = 'CAT-UASG',
  ANALISAPED = 'ANALISAPED',
  USRCICS = 'CAT-CICS'
}
